import { render } from "./SideBarMenu.html?vue&type=template&id=e38a8c38&scoped=true&ts=true&external"
import script from "./SideBarMenu.ts?vue&type=script&lang=ts&external"
export * from "./SideBarMenu.ts?vue&type=script&lang=ts&external"

import "./SideBarMenu.scss?vue&type=style&index=0&id=e38a8c38&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38a8c38"]])

export default __exports__